import { CouponType } from './adminUserCoupons.actions'
import { UserCouponProductName } from './userCoupons.slice'

export interface AssignableCouponOption {
  key: string
  text: string
  value: string
}

export interface AssignableCouponTypes {
  taxConsultationCoupons?: CouponType[]
  payrollCoupons?: CouponType[]
}

/**
 * Flattens the assignable coupon lists (grouped by product on the backend) into
 * a single dropdown option list, plus a lookup from coupon id to its product so
 * the caller can submit the correct `productName`.
 */
export const buildAssignableCouponOptions = (
  couponTypes?: AssignableCouponTypes
): {
  options: AssignableCouponOption[]
  productNameByCouponId: Map<string, UserCouponProductName>
} => {
  const assignable = [
    ...(couponTypes?.taxConsultationCoupons ?? []).map((coupon) => ({
      coupon,
      productName: UserCouponProductName.taxAdvisory,
      label: 'Tax advisory',
    })),
    ...(couponTypes?.payrollCoupons ?? []).map((coupon) => ({
      coupon,
      productName: UserCouponProductName.payroll,
      label: 'Payroll',
    })),
  ]
  return {
    options: assignable.map(({ coupon, label }) => ({
      key: coupon.id,
      text: `${coupon.name} (${label})`,
      value: coupon.id,
    })),
    productNameByCouponId: new Map(
      assignable.map(({ coupon, productName }) => [coupon.id, productName])
    ),
  }
}
